import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "order-item__article" };
const _hoisted_2 = { class: "order-item__name" };
const _hoisted_3 = { class: "order-item__identifiers" };
const _hoisted_4 = {
    key: 0,
    class: "order-item__identifier"
};
const _hoisted_5 = {
    key: 1,
    class: "order-item__identifier"
};
const _hoisted_6 = { class: "order-item__taxCategory" };
const _hoisted_7 = {
    key: 0,
    class: "order-item__image"
};
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = { class: "order-item__quantity" };
const _hoisted_10 = { class: "order-item__quantity-unit" };
const _hoisted_11 = { key: 0 };
const _hoisted_12 = {
    key: 1,
    class: "order-item__unit-price"
};
const _hoisted_13 = { class: "order-item__quantity" };
const _hoisted_14 = { class: "order-item__quantity-unit" };
const _hoisted_15 = {
    key: 0,
    class: "order-item__unit-price"
};
const _hoisted_16 = { class: "order-item__quantity" };
const _hoisted_17 = {
    key: 0,
    class: "order-item__quantity"
};
const _hoisted_18 = {
    key: 1,
    class: "order-item__quantity"
};
const _hoisted_19 = { class: "order-item__confirmation" };
const _hoisted_20 = { key: 0 };
const _hoisted_21 = { key: 1 };
const _hoisted_22 = { class: "order-item__quantity" };
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { key: 1 };
import { computed } from "vue";
import { formatCHF } from "@/utils/currency";
export default /*@__PURE__*/ _defineComponent({
    __name: 'VensoInvoiceRequestOrderItem',
    props: {
        item: {},
        noticeItem: {},
        currency: {},
        locked: { type: Boolean },
        receiptItem: {}
    },
    setup(__props) {
        const props = __props;
        const itemTotal = computed(() => {
            let quantity = props.item.quantity;
            if (props.receiptItem != null) {
                quantity = props.receiptItem.receivedQuantity;
            }
            else if (props.noticeItem != null) {
                quantity = props.noticeItem.quantity;
            }
            return formatCHF(quantity * Number(props.item.unitPrice));
        });
        const taxRate = computed(() => {
            if (!props.item.taxRate) {
                return 'n.a.';
            }
            return formatCHF(Number(props.item.taxRate) * 100) + '%';
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("tr", {
                class: _normalizeClass(["order-item", {
                        'order-item--notified': __props.noticeItem,
                        'order-item--notified-partially': __props.noticeItem && __props.noticeItem.quantity < __props.item.quantity
                    }])
            }, [
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.item.article.internalProductName), 1),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_3, [
                            (__props.item.article.gtin)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('venso_article.gtin_short')) + ":\n                        " + _toDisplayString(__props.item.article.gtin), 1))
                                : _createCommentVNode("", true),
                            _cache[0] || (_cache[0] = _createTextVNode()),
                            (__props.item.article.supplierArticleNumber)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('venso_article.supplierArticleNumber_short')) + ":\n                        " + _toDisplayString(__props.item.article.supplierArticleNumber), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('venso_order_item.tax')) + " " + _toDisplayString(taxRate.value), 1)
                    ])
                ]),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("td", null, [
                    (__props.item?.article.imageUri)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("img", {
                                src: __props.item?.article.imageUri,
                                alt: __props.item?.article?.internalProductName
                            }, null, 8, _hoisted_8)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _cache[6] || (_cache[6] = _createTextVNode()),
                _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        (__props.item)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(__props.currency) + " " + _toDisplayString(_unref(formatCHF)(__props.item?.basePrice)), 1))
                            : _createCommentVNode("", true),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        (__props.item && __props.item.baseUnit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t('venso_order_item.per_unit', { unit: _ctx.$t(`VensoUnit.${__props.item.baseUnit}`) })), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[7] || (_cache[7] = _createTextVNode()),
                _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", null, _toDisplayString(__props.currency) + " " + _toDisplayString(_unref(formatCHF)(__props.item?.unitPrice ?? __props.noticeItem?.unitPrice)), 1),
                        _cache[4] || (_cache[4] = _createTextVNode()),
                        (__props.item && __props.item.unit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t('venso_order_item.per_unit', {
                                unit: `${_ctx.$t(`VensoUnit.${__props.item.unit}`)} ${__props.item.article.variableConversionFactor ? _ctx.$t('venso_order_item.approx_at') : _ctx.$t('venso_order_item.at')} ${Number(__props.item.article.priceUnitPerOrderUnitFactor).toString()} ${_ctx.$t(`VensoUnit.${__props.item.article.priceUnit}`)}`
                            })), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _cache[8] || (_cache[8] = _createTextVNode()),
                _createElementVNode("td", _hoisted_16, _toDisplayString(__props.currency) + " " + _toDisplayString(itemTotal.value), 1),
                _cache[9] || (_cache[9] = _createTextVNode()),
                (__props.item.quantity)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(__props.item.quantity) + " " + _toDisplayString(_ctx.$t(`VensoUnit.${__props.item.article.orderUnit}`)), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_18, "\n            -\n        ")),
                _cache[10] || (_cache[10] = _createTextVNode()),
                _createElementVNode("td", null, [
                    _createElementVNode("div", _hoisted_19, [
                        (__props.noticeItem != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(__props.noticeItem.quantity) + " " + _toDisplayString(__props.item.article.orderUnit ? _ctx.$t(`VensoUnit.${__props.item.article.orderUnit}`) : ""), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_21, "\n                n.a.\n            "))
                    ])
                ]),
                _cache[11] || (_cache[11] = _createTextVNode()),
                _createElementVNode("td", _hoisted_22, [
                    (__props.receiptItem != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(__props.receiptItem.receivedQuantity) + " " + _toDisplayString(__props.item.article.orderUnit ? _ctx.$t(`VensoUnit.${__props.item.article.orderUnit}`) : ""), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_24, "\n                -\n            "))
                ])
            ], 2));
        };
    }
});
